import React from "react";
import { Link as GatsbyLink } from "gatsby";

export default function Link({ url, label, onClick, children, ...others }) {
  const initChar = url.substr(0, 1);
  const isRelative = initChar === "/" && url.substr(0, 5) !== "/blog";

  const handleClick = (e) => {
    const [pathname, fragment] = url.split("#");
    const hasValidFragment =
      window.location.pathname === pathname && !!fragment;

    if (hasValidFragment) {
      const el = document.getElementById(fragment);
      if (!el) {
        window.location.href = url;
        return;
      }

      if (el.scrollIntoView) {
        el.scrollIntoView({ behavior: "smooth" });
      } else {
        window.scrollTo(0, el.offsetTop);
      }

      e.preventDefault();
    }

    if (onClick) {
      onClick(e);
    }
  };

  if (isRelative) {
    return (
      <GatsbyLink to={url} onClick={handleClick} {...others}>
        {children || <div>{label}</div>}
      </GatsbyLink>
    );
  } else {
    return (
      <a href={url} onClick={handleClick} {...others}>
        {children || <div>{label}</div>}
      </a>
    );
  }
}
